export default __webpack_public_path__ + "static/media/ic_warning_circle.c6c94eac.svg";